import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/select.svg'
import _imports_1 from '@/assets/icons/bridge-arrow.svg'


const _hoisted_1 = { class: "bg-black bg-opacity-50 p-4 rounded-lg flex flex-row inputs-container" }
const _hoisted_2 = { class: "origin flex-grow relative" }
const _hoisted_3 = {
  key: 0,
  class: "validation-err text-red-500 text-xs"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Origin")
const _hoisted_5 = { class: "flex flex-row items-center max-w-[300]" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "capitalize opacity-60"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "ml-1"
}, null, -1 /* HOISTED */)
const _hoisted_9 = { class: "flex flex-row justify-between" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Address")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "arrow mx-4"
}, null, -1 /* HOISTED */)
const _hoisted_12 = { class: "flex-grow relative" }
const _hoisted_13 = {
  key: 0,
  class: "validation-err text-red-500 text-xs"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Destination")
const _hoisted_15 = { class: "flex flex-row items-center max-w-[300]" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "capitalize opacity-60"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "ml-1"
}, null, -1 /* HOISTED */)
const _hoisted_19 = { class: "flex flex-row justify-between relative" }
const _hoisted_20 = {
  key: 0,
  class: "validation-err text-red-500 text-xs"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Address")
const _hoisted_22 = { class: "flex flex-row" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" edit ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_edit_recipient = _resolveComponent("edit-recipient")!
  const _component_network_select = _resolveComponent("network-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" origin network not selected "),
      (_ctx.v$.originNetwork.$invalid)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " * required "))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" network selector "),
      _createElementVNode("div", {
        class: "flex flex-row items-center justify-between cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (this.showSelectOriginNetwork = true))
      }, [
        _createVNode(_component_n_text, { class: "opacity-50 mr-1" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_n_text, { class: "font-bold text-base" }, {
            default: _withCtx(() => [
              (_ctx.originNetwork)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getDisplayName(_ctx.originNetwork)), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, "Select network"))
            ]),
            _: 1 /* STABLE */
          }),
          _hoisted_8
        ])
      ]),
      _createVNode(_component_n_divider, { class: "divider" }),
      _createCommentVNode(" origin address "),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_n_text, { class: "opacity-50 mr-1" }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_n_text, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.truncateAddr(_ctx.originAddr) || '—'), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createCommentVNode(" arrow "),
    _hoisted_11,
    _createCommentVNode(" right "),
    _createElementVNode("div", _hoisted_12, [
      _createCommentVNode(" destination network not selected "),
      (_ctx.v$.destinationNetwork.$invalid)
        ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.v$.destinationNetwork.$errors[0].$message), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" network selector "),
      _createElementVNode("div", {
        class: "flex flex-row items-center justify-between cursor-pointer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (this.showSelectDestinationNetwork = true))
      }, [
        _createVNode(_component_n_text, { class: "opacity-50 mr-1" }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_n_text, { class: "font-bold text-base" }, {
            default: _withCtx(() => [
              (_ctx.destinationNetwork)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.getDisplayName(_ctx.destinationNetwork)), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("span", _hoisted_17, "Select network"))
            ]),
            _: 1 /* STABLE */
          }),
          _hoisted_18
        ])
      ]),
      _createVNode(_component_n_divider, { class: "divider" }),
      _createCommentVNode(" destination address "),
      _createElementVNode("div", _hoisted_19, [
        _createCommentVNode(" invalid destination address "),
        (_ctx.v$.destinationAddr.$invalid)
          ? (_openBlock(), _createElementBlock("p", _hoisted_20, " * invalid "))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_n_text, { class: "opacity-50 mr-1" }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_n_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.truncateAddr(_ctx.destinationAddr) || '—'), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          (_ctx.destinationAddr)
            ? (_openBlock(), _createBlock(_component_n_button, {
                key: 0,
                text: "",
                color: "#fff",
                class: "opacity-50 ml-1 cursor-pointer",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showEditRecipient = true))
              }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        _createCommentVNode(" Edit destination address modal "),
        _createVNode(_component_edit_recipient, {
          show: _ctx.showEditRecipient,
          onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showEditRecipient = false))
        }, null, 8 /* PROPS */, ["show"])
      ])
    ]),
    _createCommentVNode(" origin network select modal "),
    _createVNode(_component_network_select, {
      show: _ctx.showSelectOriginNetwork,
      onHide: _cache[4] || (_cache[4] = ($event: any) => (this.showSelectOriginNetwork = false))
    }, null, 8 /* PROPS */, ["show"]),
    _createCommentVNode(" destination network select modal "),
    _createVNode(_component_network_select, {
      show: _ctx.showSelectDestinationNetwork,
      isSelectingDestination: "",
      onHide: _cache[5] || (_cache[5] = ($event: any) => (this.showSelectDestinationNetwork = false))
    }, null, 8 /* PROPS */, ["show"])
  ]))
}